import React, { Component } from "react";
import { getDb, setDb, sendArrayDb, readXBoards, saveJPros, doSave, contSaveSchedule,
  } from "../C18AiUtils";
import {wsTrans} from '../../utils/utils'
import { cl,globs } from "../../../components/utils/utils";

const CHAN = 255;
const TAB = "zone_configuration_settings";
const VOL_UNIT_COLUMN = "Volume Measurement Units"
const TMP_UNIT_COLUMN = "Temperature Units"

const ROW = 0;

function toDisplay(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n.toFixed(2) : "0.00";
}

function blankNutes() {
  return [
    "None", "None", "None", "None", "None", "None", "None", "None",
    "None", "None", "None", "None", "None", "None", "None", "None",
  ];
}

function blankJPro(index) {
  return {
    name: `jPro ${index + 1}`,
    type:"jPro",
    mbAddr: 10,
    nutes: blankNutes(),
    cps: [1, 2, 3, 4, 5, 6, 7, 8, 1, 2, 3, 4, 5, 6, 7, 8],
    notUsed: false,
  };
}

function isConfiguredNute(name) {
  return name != null && String(name).trim() !== "" && String(name) !== "None";
}

function countPumpersInUse(jp) {
  return (jp.nutes || []).filter(isConfiguredNute).length;
}

export default class DoserSystemSettings2 extends Component {
  state = {
    volUnits: "",
    tmpUnits: "",
//     ecSp: "",
//     ecCal: "",
//     phSp: "",
//     phCal: "",
  };

  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
//     cl(this.props)
    const { zInd, vUnitId, tUnitId } = this.props;
    this.setState({
      volUnits: vUnitId,//+getDb(zInd, CHAN, TAB, VOL_UNIT_COLUMN, ROW) ?? "",
      tmpUnits: tUnitId,//+getDb(zInd, CHAN, TAB, TMP_UNIT_COLUMN, ROW) ?? "",
//       ecSp: toDisplay(getDb(zInd, CHAN, TAB, "dose_ec_sp", ROW)),
//       ecCal: toDisplay(getDb(zInd, CHAN, TAB, "dose_ec_cal", ROW)),
//       phSp: toDisplay(getDb(zInd, CHAN, TAB, "dose_ph_sp", ROW)),
//       phCal: toDisplay(getDb(zInd, CHAN, TAB, "dose_ph_cal", ROW)),
    });
    this.subscribe_savePageEvent = globs.events.subscribe("savePageEvent", this.savePage);
  }

  componentWillUnmount() {
    if (this.subscribe_savePageEvent && this.subscribe_savePageEvent.remove) {
      this.subscribe_savePageEvent.remove();
    }
  }

  setSavePage = (set) => {
    globs.events.publish("savePageEnable", set);
    if (this.props.onChange) {
      this.props.onChange({
        type: "change",
        value: set ? this.savePage : null,
      });
    }
  };

  handleChange = (field, value) => {
    this.setState({ [field]: value });
    this.setSavePage(true)

//     globs.events.publish("savePageEnable", true);
  };

  emitJPlus = (next) => {
    const { onChange } = this.props;
    this.setSavePage(true)
//     globs.events.publish("savePageEnable", true);
    if (typeof onChange === "function") {
      onChange({ type: "state", value: next });
    }
  };

  getActiveJPlusEntries = () => {
//     cl(this.props)
    const list = Array.isArray(this.props.jPlus) ? this.props.jPlus : [];
    const out = [];
    list.forEach((jp, index) => {
      if (jp && !jp.notUsed) {
        out.push({ jp, index });
      }
    });
    return out;
  };

  updateJPlusAt = (index, patch) => {
    const list = (Array.isArray(this.props.jPlus) ? this.props.jPlus : []).slice(0);
    if (!list[index]) return;
    list[index] = { ...list[index], ...patch };
    this.emitJPlus(list);
  };

  addJPro = () => {
    const list = (Array.isArray(this.props.jPlus) ? this.props.jPlus : []).slice(0);
    const unusedIdx = list.findIndex((jp) => jp && jp.notUsed);
    if (unusedIdx >= 0) {
      list[unusedIdx] = { ...list[unusedIdx], notUsed: false };
      this.emitJPlus(list);
      return;
    }
    list.push(blankJPro(list.length));
    cl(list)
    this.emitJPlus(list);
  };

  deleteJPro = (index) => {
    const list = (Array.isArray(this.props.jPlus) ? this.props.jPlus : []).slice(0);
    if (!list[index]) return;
    list[index] = { ...list[index], notUsed: true };
    this.emitJPlus(list);
  };

  saveConfig=async()=>{// activated by onImportFileSelected
    cl("saveConfig")
//     cl(this.props)
    let pr=this.props
    for(let cfg of ["jPlus","recipes","schedule","valves"]){
      await doSave(cfg, this.props[cfg],this.props.zoneId);
    }
    await contSaveSchedule(pr.schedule, pr.recipes, pr.jPlus, pr.jPro, pr.zInd);
  }

  doSave=async(field,value)=>{
//     cl(`save ${field}`)
//     cl(this.props)
    let {zoneId}=this.props
    let pa=this.props.parms
    let st=this.state
    let body={
      zoneId:zoneId,//pa.zone,
      type:field,
      value:value,//st[field]
    }
//     cl(body)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/pearlDoser", method: "update",
      sessionId: globs.userData.session.sessionId, body: body})
  }

  savePage = async () => {
//     cl(this.props)
    const { volUnits, tmpUnits, saveConfig } = this.state;
    const { jPlus,zInd,onChange } = this.props;
//     cl(jPlus)
    this.setSavePage(false)
    if(saveConfig){return this.saveConfig()}
//     cl("saving units")

    let arr = [];

//     const clamp = (v, min, max) => Math.min(max, Math.max(min, v));
//     const toNum = (v, fallback = 0) => {
//       const n = Number(v);
//       return Number.isFinite(n) ? n : fallback;
//     };
//     const round2 = (v) => Math.round(v * 100) / 100;

//     const units = Math.round(clamp(toNum(kFact, 0), 0, 10000));

    setDb(arr, zInd, CHAN, TAB, VOL_UNIT_COLUMN, ROW, volUnits);
    setDb(arr, zInd, CHAN, TAB, TMP_UNIT_COLUMN, ROW, tmpUnits);
    onChange([
      {type:"vUnitId",value:+volUnits},
      {type:"tUnitId",value:+tmpUnits},])

    await sendArrayDb(arr);
    let jPlusUsed=jPlus.filter(jp=>!jp.notUsed)
    let xBoards=readXBoards(zInd)
    await saveJPros(zInd,jPlusUsed,xBoards)
    this.doSave("jPlus",jPlus)
  };

  buildExportPayload = () => {
    const { schedule, recipes, jPlus, valves } = this.props;
    return {
      schedule: schedule || [],
      recipes: recipes || [],
      jPlus: jPlus || [],
      valves: valves || [],
    };
  };

  exportSystemFile = async () => {
    const payload = this.buildExportPayload();
    const text = JSON.stringify(payload, null, 2);
    const filename = `pearl-idoser-system-${new Date().toISOString().slice(0, 10)}.json`;

    if (typeof window !== "undefined" && window.showSaveFilePicker) {
      try {
        const handle = await window.showSaveFilePicker({
          suggestedName: filename,
          types: [
            {
              description: "Pearl iDoser system file",
              accept: { "application/json": [".json"] },
            },
          ],
        });
        const writable = await handle.createWritable();
        await writable.write(text);
        await writable.close();
        return;
      } catch (err) {
        if (err && err.name === "AbortError") return;
      }
    }

    const blob = new Blob([text], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  importSystemFile = () => {
    if (this.fileInputRef && this.fileInputRef.current) {
      this.fileInputRef.current.value = "";
      this.fileInputRef.current.click();
    }
  };

  onImportFileSelected = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    try {
      const text = await file.text();
      const parsed = JSON.parse(text);
      if (!parsed || typeof parsed !== "object") {
        throw new Error("Invalid system file");
      }
      const value = {
        schedule: Array.isArray(parsed.schedule) ? parsed.schedule : [],
        recipes: Array.isArray(parsed.recipes) ? parsed.recipes : [],
        jPlus: Array.isArray(parsed.jPlus) ? parsed.jPlus : [],
        valves: Array.isArray(parsed.valves) ? parsed.valves : [],
      };
      const { onChange } = this.props;
      if (typeof onChange === "function") {
        cl(value)
        onChange({ type: "state", value });
        this.setSavePage(true)
        this.setState({saveConfig:true})
//         globs.events.publish("savePageEnable", true);
      }
    } catch (err) {
      cl({ DoserSystemSettings2: "import failed", error: err && err.message });
      window.alert("Could not import system file. Check that it is valid JSON.");
    }
  };

  render() {
    const { volUnits, tmpUnits } = this.state;

    const labelStyle = {
      fontSize: 12,
      color: "#666",
      display: "block",
      marginBottom: 6,
    };
    const inputStyle = {
//       width: "100px",
      boxSizing: "border-box",
      borderRadius: 10,
      padding: "8px",
    };
    const backupTitle = {
      fontSize: 16,
      fontWeight: 700,
      color: "#222",
      margin: "28px 0 8px 0",
    };
    const backupText = {
      fontSize: 13,
      color: "#888",
      lineHeight: 1.45,
      marginBottom: 12,
      maxWidth: 560,
    };
    const backupBtn = {
      fontSize: 14,
      padding: "8px 14px",
      borderRadius: 8,
      border: "1px solid #ccc",
      background: "#fff",
      color: "#222",
      cursor: "pointer",
      fontFamily: "inherit",
    };
    const jproHeader = {
      display: "flex",
      alignItems: "center",
      gap: 10,
      fontSize: 12,
      fontWeight: 600,
      color: "#888",
      marginBottom: 8,
    };
    const jproRow = {
      display: "flex",
      alignItems: "center",
      gap: 10,
      marginBottom: 8,
    };
    const jproId = {
      width: 24,
      flexShrink: 0,
      fontSize: 14,
      color: "#222",
      fontVariantNumeric: "tabular-nums",
    };
    const jproName = {
      ...inputStyle,
      flex: "1 1 160px",
      minWidth: 140,
      maxWidth: 280,
      height: 36,
    };
    const jproAddr = {
      ...inputStyle,
      width: 72,
      height: 36,
      flexShrink: 0,
    };
    const jproPumpers = {
      fontSize: 13,
      color: "#666",
      flex: "0 1 auto",
      whiteSpace: "nowrap",
    };
    const jproDelete = {
      width: 32,
      height: 32,
      borderRadius: 6,
      border: "1px solid #ccc",
      background: "#fff",
      color: "#888",
      cursor: "pointer",
      fontSize: 16,
      lineHeight: 1,
      flexShrink: 0,
      fontFamily: "inherit",
    };
    const addJProBtn = {
      display: "inline-flex",
      alignItems: "center",
      marginTop: 4,
      marginBottom: 8,
      padding: "8px 14px",
      borderRadius: 8,
      border: "1px dashed #ccc",
      background: "#fff",
      color: "#666",
      fontSize: 14,
      fontWeight: 600,
      cursor: "pointer",
      fontFamily: "inherit",
    };

    let volUnitSelVals=[
      {t: "Gallons and Ratio", v: 3},
      {t: "Liters and Ratio", v: 4},
      {t: "Liters and Milliliters (L/ml)", v: 0},
      {t: "Gallons and Ounces (gal/oz)", v: 1},
      {t: "Gallons and Milliliters (gal/ml)", v: 2},
    ]
    let tmpUnitSelVals=[
      "Fahrenheit",
      "Celsius",
    ]
    var makeOpts=(vals)=>{
      return vals.map((u,i)=>{
        if (u && typeof u === "object") {
          return <option key={u.v} value={u.v}>{u.t}</option>
        }
        return <option key={i} value={i}>{u}</option>
      })
    }

    const activeJPros = this.getActiveJPlusEntries();

    return (
      <div
        style={{
          fontFamily: "system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
          padding: 8,
        }}
      >
      <h3>System Settings</h3>
        <div style={{ marginBottom: 12 }}>
          <label style={labelStyle}>Volume Units</label>
          <select
            style={inputStyle}
            value={volUnits}
            onChange={e=>this.handleChange("volUnits",e.target.value)}
          >
            {makeOpts(volUnitSelVals)}
          </select>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={labelStyle}>Temperature Units</label>
          <select
            style={inputStyle}
            value={tmpUnits}
            onChange={e=>this.handleChange("tmpUnits",e.target.value)}
          >
            {makeOpts(tmpUnitSelVals)}
          </select>
        </div>

        <div style={{ marginBottom: 8 }}>
          <h4 style={{ ...backupTitle, marginTop: 20 }}>JPro Controllers</h4>
          <p style={backupText}>
            Each unit is a Modbus RTU slave on the Pearl&apos;s COM4 bus. Address 10
            is the J Pro factory default.
          </p>
          <div style={jproHeader}>
            <div style={jproId}>#</div>
            <div style={{ ...jproName, border: "none", height: "auto", padding: 0 }}>Name</div>
            <div style={{ width: 72, flexShrink: 0 }}>Modbus address</div>
            <div style={jproPumpers}>Pumpers</div>
            <div style={{ width: 32, flexShrink: 0 }} />
          </div>
          {activeJPros.map(({ jp, index }, displayIdx) => {
//             cl(jp)
            let isJpro=jp.type!="jPlus"
            const inUse = countPumpersInUse(jp);
            const total = (jp.nutes || blankNutes()).length;
            return (
              <div key={index} style={jproRow}>
                <div style={jproId}>{displayIdx + 1}</div>
                <input
                  type="text"
                  style={jproName}
                  value={jp.name == null ? "" : jp.name}
                  onChange={(e) => this.updateJPlusAt(index, { name: e.target.value })}
                  aria-label={`JPro ${displayIdx + 1} name`}
                />
                <input
                  type="number"
                  min={1}
                  max={255}
                  style={jproAddr}
                  value={jp.mbAddr == null ? "" : jp.mbAddr}
                  onChange={(e) => {
                    const raw = e.target.value;
                    if (raw === "") return;
                    const n = Number(raw);
                    if (Number.isNaN(n)) return;
                    this.updateJPlusAt(index, {
                      mbAddr: Math.max(1, Math.min(255, Math.floor(n))),
                    });
                  }}
                  aria-label={`JPro ${displayIdx + 1} Modbus address`}
                />
                <div style={jproPumpers}>{`${inUse} in use / ${total}`}</div>
                &nbsp;&nbsp;
                <input id="isJpro" type="checkbox"
                  checked={isJpro}
                  onChange={(e) => {
                    const raw = e.target.checked;
                    let nutes=(raw)?
                      [...jp.nutes, ...Array(8).fill("None")].slice(0, 16):
                      jp.nutes.slice(0,8)
                    this.updateJPlusAt(index, {
                      type:(raw)?"jPro":"jPlus",
                      nutes,
                    });
                  }}
                  style={{minWidth:0}}/>
                <span>JPro</span>
                <button
                  type="button"
                  style={jproDelete}
                  title="Delete JPro"
                  aria-label={`Delete JPro ${displayIdx + 1}`}
                  onClick={() => this.deleteJPro(index)}
                >
                  ×
                </button>
              </div>
            );
          })}
          <button type="button" style={addJProBtn} onClick={this.addJPro}>
            + Add JPro/jPlus
          </button><br/>
        </div>

        <div>
          <h4 style={backupTitle}>Backup &amp; transfer</h4>
          <p style={backupText}>
            The whole console as one file — installation, JPro units and pumpers,
            recipes, schedule, limits and settings. Move a configured system
            between machines, or keep one file per customer.
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 12 }}>
            <button type="button" style={backupBtn} onClick={this.exportSystemFile}>
              Export system file
            </button>
            <button type="button" style={backupBtn} onClick={this.importSystemFile}>
              Import system file...
            </button>
          </div>
          <p style={backupText}>
            Import replaces everything, after showing you what is in the file.
            Files from an earlier version of this console are upgraded on the way
            in.
          </p>
          <input
            ref={this.fileInputRef}
            type="file"
            accept="application/json,.json"
            style={{ display: "none" }}
            onChange={this.onImportFileSelected}
          />
        </div>
      </div>
    );
  }
}
